import { minimumLevelStream } from "./minimumLevelStream";
/**
 * Sends error logs to Datadog RUM error tracking.
 */
export const datadogErrorTrackingStream = (datadogRum) => minimumLevelStream("error")((event) => {
    var _a;
    const error = (_a = event.error) !== null && _a !== void 0 ? _a : new Error(event.message);
    const context = Object.assign(Object.assign({}, event.context), { message: event.message });
    datadogRum.addError(error, context);
});
//# sourceMappingURL=datadogErrorTrackingStream.js.map